import { render } from "./CheckStudent.vue?vue&type=template&id=20dbd482&scoped=true&ts=true"
import script from "./CheckStudent.vue?vue&type=script&lang=ts"
export * from "./CheckStudent.vue?vue&type=script&lang=ts"

import "./CheckStudent.vue?vue&type=style&index=0&id=20dbd482&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dbd482"]])

export default __exports__